import * as React from "react";
import queryString from "query-string-for-all";
import { RouteComponentProps } from "react-router";
import { useDispatch } from "./";
import {
  GroupBy,
  SortBy,
  Category,
} from "../../components/Analysis/utils/types";
import { setPersisted } from "../../utils/storage";
import {
  INSIGHTS_LS_KEY,
  SORT_BY_KEY,
  GROUP_BY_KEY,
} from "../../components/Analysis/utils/constants";

export function useActions() {
  const dispatch = useDispatch();

  const toggleExpandAll = React.useCallback(function setExpandAll() {
    dispatch({ type: "TOGGLE_EXPAND_ALL" });
  }, []);

  const setSortBy = React.useCallback(function setSortBy(sortBy: SortBy) {
    dispatch({ type: "SET_SORT_BY", sortBy });
    setPersisted({ key: INSIGHTS_LS_KEY, prop: SORT_BY_KEY }, sortBy);
  }, []);

  const setGroupBy = React.useCallback(function setGroupBy(groupBy: GroupBy) {
    dispatch({ type: "SET_GROUP_BY", groupBy });
    setPersisted({ key: INSIGHTS_LS_KEY, prop: GROUP_BY_KEY }, groupBy);
  }, []);

  const setCategory = React.useCallback(function setCategory(
    history: RouteComponentProps["history"],
    category: Category
  ) {
    const qs = queryString.parse(history.location.search);
    const stringified = queryString.stringify({ ...qs, category });
    history.replace({ search: stringified });
    dispatch({ type: "SET_CATEGORY", category });
  },
  []);

  return {
    toggleExpandAll,
    setGroupBy,
    setSortBy,
    setCategory,
  };
}
